/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserSummaryBatchResponse {
    getFixupPrototypeFunction() { return UserSummaryBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<UserSummaryBatchResponse>): UserSummaryBatchResponse {
        let obj = Object.assign(new UserSummaryBatchResponse(), model);
        UserSummaryBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserSummaryBatchResponse>): UserSummaryBatchResponse {
        if (!model) return null;
        return UserSummaryBatchResponse.newInstance(<UserSummaryBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserSummaryBatchResponse) {
        if (!obj) return;

        models.UserSummaryBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserSummaryBatchResponse): boolean {
        Object.setPrototypeOf(obj, UserSummaryBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.UserSummary.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.UserSummary; };

}
